export default {
  activeFeedbackItems: (state) => state.feedbackItems.filter((f) => f.isActive),
  inActiveFeedbackItems: (state) => state.feedbackItems.filter((f) => !f.isActive),
};
